import Moment from 'moment';
import * as FW from 'fw/system/FW'

// Parsing
export const parseDecimal = function (value) {
    let result = null;

    if (value === undefined || value === null)
        return "";

    value = value.toString();

    if (value !== "") {
        value = value.toString().replace(/,/g, '');
        let number = Number(value);

        if (isNaN(number))
            return null;
        else
            return number;
    }

    return result;
}

export const parseInt = function (value) {
    return Math.floor(parseDecimal(value));
}

export const parseCurrency = function (value) {
    let result = null;

    if (value === undefined || value === null)
        return result;

    value = value.toString();
    value = value.replace("$", '');
    value = value.replace("(", '-');
    value = value.replace(")", '');

    if (value !== "")
        return parseDecimal(value);

    return result;
};

export const parsePrct = function (value) {
    let result = 0;

    if (value === undefined || value === null)
        return "";

    value = value.toString();
    value = value.replace("%", '');

    if (value !== "") {
        return parseDecimal(value);
    }

    return result;
};

export const parseDate = function (value) {
    const dateFormat = FW.getSettings().dateFormat;

    if (value === undefined || value === null)
        return "";

    let parsed;

    if (value._isAMomentObject) {
        parsed = value.format(dateFormat);
    } else {
        const iso = Moment(value, "YYYY-MM-DD[T]HH:mm:ss");
        const usDate = Moment(value, "MM/DD/YYYY[T]HH:mm:ss");
        const dateValue = Moment(value, dateFormat);

        if(usDate.isValid() && value.toString().includes('/'))
            parsed = usDate.format(dateFormat);

        else if (iso.isValid())
            parsed = iso.format(dateFormat);

        else if (dateValue.isValid())
            parsed = dateValue.format(dateFormat);

        else
            parsed = "";
    }

    return parsed;
}



// WEBPACK FOOTER //
// ./src/fw/misc/Parsing.js